module.exports = __webpack_public_path__ + "public/Icons/dietary.svg?c180f7a2";